import React from 'react';
import accessibleSvg from 'utils/accessibleSvg';

export default accessibleSvg(({ children, ...props }) => (
  <svg fill="currentColor" viewBox="0 0 297.3096 168.64999" {...props}>
    {children}
    <path d="M20.004806 0H277.30481c17.8 0 26.7 21.5 14.1 34.1l-128.6 128.7c-7.8 7.8-20.5 7.8-28.3 0L5.9048057 34.1c-12.6-12.6-3.7-34.1 14.1000003-34.1z" />
  </svg>
));
